import { apiClient } from './client';
import { createCrudApi } from './crud';
import type { ApiSuccess } from '../types';

export interface WhatsAppSettings {
  provider: string;
  fromIdentifier: string | null;
  accountSid: string | null;
  hasApiKey: boolean;
  active: boolean;
  source: string;
}

export interface WhatsAppTemplate {
  id: number;
  code: string;
  name: string;
  body: string;
  category: string | null;
  status: string;
  createdAt: string;
}

export interface CreateTemplateInput {
  code: string;
  name: string;
  body: string;
  category?: string;
  status?: string;
}

export interface WhatsAppDashboard {
  total: number;
  byStatus: Record<string, number>;
  byDelivery: Record<string, number>;
  sent: number;
  failed: number;
  queued: number;
  recent: Array<Record<string, unknown>>;
}

export const whatsappSettingsApi = {
  async get(): Promise<WhatsAppSettings> {
    return (await apiClient.get<ApiSuccess<WhatsAppSettings>>('/whatsapp-settings')).data.data;
  },
  async update(input: Partial<WhatsAppSettings> & { apiKey?: string }): Promise<WhatsAppSettings> {
    return (await apiClient.put<ApiSuccess<WhatsAppSettings>>('/whatsapp-settings', input)).data.data;
  },
  async test(toNumber: string): Promise<{ provider: string; status: string }> {
    return (await apiClient.post<ApiSuccess<{ provider: string; status: string }>>('/whatsapp-settings/test', { toNumber })).data.data;
  },
};

export const whatsappTemplatesApi = createCrudApi<WhatsAppTemplate, CreateTemplateInput>('whatsapp-templates');

export const whatsappMessagesApi = {
  async list(params: Record<string, unknown> = {}) {
    const { data } = await apiClient.get<ApiSuccess<Array<Record<string, unknown>>>>('/whatsapp-messages', { params });
    return { data: data.data, meta: data.meta };
  },
  async dashboard(): Promise<WhatsAppDashboard> {
    return (await apiClient.get<ApiSuccess<WhatsAppDashboard>>('/whatsapp-messages/dashboard')).data.data;
  },
  async process(): Promise<{ processed: number; sent: number; failed: number }> {
    return (await apiClient.post<ApiSuccess<{ processed: number; sent: number; failed: number }>>('/whatsapp-messages/process', {})).data.data;
  },
  async retry(id: number): Promise<void> {
    await apiClient.post(`/whatsapp-messages/${id}/retry`, {});
  },
};
